import { CustomerDocument, useCustomerQuery } from '@graphcommerce/magento-customer'
import { PageMeta } from '@graphcommerce/magento-store'
import { i18n } from '@lingui/core'
import { Paper } from '@mui/material'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { OrdersTabs } from '../../../components/Account/OrdersTabs'
import { AccountOrders } from '../../../components/CustomerAccount/AccountOrders/AccountOrders'
import { OrderNumberSearch } from '../../../components/CustomerAccount/AccountOrders/OrderNumberSearch'
import { OrderItemSkeleton } from '../../../components/Skeleton/OrderItemSkeleton'
import { AccountDashboardOrdersDocument } from '../../../graphql/AccountDashboardOrders.gql'
import useCallAPI from '../../../hooks/useCallAPI'

export default function AccountOrdersPage() {
  const { query } = useRouter()
  // const pageSize = 20
  const [value, setValue] = useState('0')
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [pageSize, setPageSize] = useState(20)

  const orders = useCustomerQuery(AccountDashboardOrdersDocument, {
    fetchPolicy: 'cache-and-network',
    variables: {
      pageSize: 1000,
      currentPage: 1,
      search: query?.search?.toString() || undefined,
      sort: { sort_direction: 'DESC', sort_field: 'CREATED_AT' },
    },
  })
  const { data, loading } = orders
  const customer = data?.customer
  const [acessToken, setAccessToken] = useState<string>()
  const [reviews, setReviews] = useState<any[]>()

  let orderItems = customer?.orders?.items

  switch (value) {
    case '0' /** ACTIVE */:
      orderItems = customer?.orders?.items.filter(
        (item) =>
          item?.status?.toUpperCase() !== 'CANCELED' &&
          item?.status?.toUpperCase() !== 'ORDER SHIPPED' &&
          item?.status?.toUpperCase() !== 'COMPLETE',
      )

      break
    case '1' /** HISTORY */:
      orderItems = customer?.orders?.items.filter(
        (item) =>
          item?.status?.toUpperCase() !== 'CANCELED' &&
          (item?.status?.toUpperCase() === 'ORDER SHIPPED' ||
            item?.status?.toUpperCase() === 'COMPLETE'),
      )
      break
    case '2' /** CANCELED */:
      orderItems = customer?.orders?.items.filter(
        (item) => item?.status?.toUpperCase() === 'CANCELED',
      )
  }
  const dashboard = useCustomerQuery(CustomerDocument, {
    fetchPolicy: 'cache-and-network',
  })

  const { apiCall: authAPICall } = useCallAPI({
    url: `${process.env.NEXT_PUBLIC_YOTPO_BASE_URL}/oauth/token?client_id=${process.env.NEXT_PUBLIC_YOTPO_APP_KEY}&client_secret=${process.env.NEXT_PUBLIC_YOTPO_SECRET_KEY}&grant_type=client_credentials`,
    contentType: 'application/json',
    method: 'GET',
  })

  const { apiCall: getAllReviewsCall } = useCallAPI({
    url: `${process.env.NEXT_PUBLIC_YOTPO_BASE_URL}/v1/apps/${process.env.NEXT_PUBLIC_YOTPO_APP_KEY}/reviews?utoken=${acessToken}&count=500`,
    contentType: 'application/json',
    method: 'GET',
  })

  useEffect(() => {
    const fetchAuthToken = async () => {
      const authRes = await authAPICall()
      if (authRes && authRes.status === 200 && authRes?.data?.access_token) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        setAccessToken(authRes?.data?.access_token)
      }
    }

    fetchAuthToken().catch((e) => {
      // addtional error handling here, the error must be set by the useCallAPI hook already
      console.error(e)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const fetchAllReviews = async () => {
      const res = await getAllReviewsCall()
      if (res && res.status === 200 && res?.data?.reviews) {
        const userReviews = res?.data?.reviews?.filter(
          (item) =>
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            item?.email?.toUpperCase() === dashboard.data?.customer?.email?.toUpperCase() &&
            item?.archived === false &&
            item?.deleted === false,
        )
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        setReviews(userReviews)
      }
    }

    if (acessToken && acessToken.length > 0) {
      fetchAllReviews().catch((e) => {
        // addtional error handling here, the error must be set by the useCallAPI hook already
        console.error(e)
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [acessToken])

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    orderItems = customer?.orders?.items?.slice(
      currentPage * pageSize - pageSize,
      currentPage * pageSize,
    )
  }, [currentPage, value, pageSize])

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (value === '0' && orderItems && orderItems?.length < 1) {
      setValue('1')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customer?.orders?.items])

  return (
    <Paper elevation={3} className='md:px-15 p-10 md:py-8'>
      <PageMeta title={i18n._(/* i18n */ 'Orders')} metaRobots={['noindex']} />
      <div className='w-full'>
        <span className='Type-XXL-Regular w-full '>Orders</span>
        <hr className='mb-2 mt-2 text-20-grey md:mb-5' />
        <div className='mb-5 flex flex-col-reverse gap-2 md:grid md:grid-cols-[60fr_40fr] md:gap-0'>
          <OrdersTabs value={value} setValue={setValue} />
          <div className='mt-[5px] flex max-h-10 w-full items-start justify-end md:mt-0 md:pb-[5px]'>
            <OrderNumberSearch />
          </div>
        </div>
        {loading ? (
          <OrderItemSkeleton />
        ) : (
          <AccountOrders
            orders={{
              items: orderItems ?? [],
              page_info: {
                // eslint-disable-next-line no-unsafe-optional-chaining
                total_pages: Math.ceil((orderItems?.length ?? 0) / pageSize),
              },
            }}
            reviews={reviews}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            activeTab={Number.parseInt(value, 10)}
          />
        )}
      </div>
    </Paper>
  )
}
